<template>
  <Btn :label="labelComputed" icon="mdi-download" @click="downloadCsv" :disabled="disabled" />
</template>

<script>
import Btn from '@/components/atoms/base/button/Btn.vue'
import moment from 'moment'

export default {
  name: 'BtnCsvDownload',

  components: { Btn, moment },

  props: {
    label: {
      type: String,
      required: false,
    },
    items: {
      type: Array,
      required: true,
    },
    itemParsed: {
      type: String,
      required: false,
      default: undefined,
    },
    fileTitle: {
      type: String,
      required: true,
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  computed: {
    labelComputed: {
      get() {
        return this.label ? this.label : this.$t('ELE0075')
      },
    },
  },
  methods: {
    downloadCsv() {
      const csv =
        this.itemParsed ??
        this.$papa.unparse(this.items, {
          // 完全に空の行、解析後に空白しかない行はスキップする
          skipEmptyLines: 'greedy',
        })
      const bom = new Uint8Array([0xef, 0xbb, 0xbf])
      let blob = new Blob([bom, csv], { type: 'text/csv' })

      let link = document.createElement('a')
      link.href = window.URL.createObjectURL(blob)

      // \/:*?"<>| はファイル名として使用できない文字であるため、"-"に置き換え
      const fileTitle = this.fileTitle.replaceAll(/[\\/:*?"<>|]/g, '-')
      const nowDatetime = moment().format('YYYYMMDDHHmmss')
      link.download = `${fileTitle}_${nowDatetime}.csv`
      link.click()
    },
  },
}
</script>
